import {
  Box,
  Button,
  Card,
  CardBody,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Skeleton,
  SkeletonText,
  Stack,
  StackDivider,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from "@chakra-ui/react";
import React from "react";
import PriceAveragesComponent from "./PriceAveragesComponent";
import BoxFlexMobile from "./BoxFlexMobile";
import FinancialData from "./FinancialData";

function SymbolData(props) {
  // console.log("changes active symbol", props);

  // const [symbolAverages, setsymbolAverages] = React.useState([]);
  // React.useEffect(() => {
  //   console.log("averages changed", props.averages);
  //   setsymbolAverages([...props.averages]);
  // }, [props.averages]);

  const [pastDate, setpastDate] = React.useState("");
  const [resetDataVisible, setresetDataVisible] = React.useState(false);

  return (
    <Box flex="4" p="4" bg="gray.50" overflowY={"auto"}>
      <Card
        // h={"100%"}
        border={"1px"}
        borderRight={"4px"}
        borderBottom={"4px"}
        borderColor={"grey"}
      >
        {/* symbol Card */}
        {/* heading: name + last update */}
        <CardBody>
          <Stack divider={<StackDivider />} spacing="4">
            <Tabs>
              <TabList>
                <Tab>Graph</Tab>
                <Tab>Financials</Tab>
              </TabList>
              <TabPanels>
                <TabPanel>
                  <SkeletonText
                    isLoaded={!!props.lastRefresh}
                    noOfLines={4}
                    spacing="4"
                    skeletonHeight="2"
                  >
                    <Flex>
                      <Box flex={1}></Box>
                      <Box p={2}>
                        <Text color={"gray"}>
                          {"Last update " + props.lastRefresh ?? "UNKN"}
                        </Text>
                      </Box>
                    </Flex>

                    <BoxFlexMobile>
                      <Box p={2} flex={1}>
                        <Text fontWeight={"bold"} fontSize={"3xl"}>
                          {props.symbol ?? "UNKN"}
                        </Text>
                      </Box>
                      <Box p={2}>
                        {props.resetVisible ? (
                          <Button
                            ml={2}
                            onClick={() => {
                              props.onResetState();
                              setresetDataVisible(false);
                            }}
                          >
                            Reset Data
                          </Button>
                        ) : (
                          <Flex p={2}>
                            {/* <Button ml={2}>find patterns</Button> */}
                            <Text>{"Date Simulation"}</Text>
                            <InputGroup ml={2}>
                              <Input
                                value={pastDate}
                                onChange={(_e) => setpastDate(_e.target.value)}
                                placeholder="Simulate Date"
                                size="md"
                                type="date"
                              />
                              <InputRightElement width="4.5rem">
                                <Button
                                  // h="1.75rem"ù
                                  size="sm"
                                  onClick={() => {
                                    // console.log(
                                    //   "formatted date",
                                    //   new Date(pastDate).toISOString().split("T")[0]
                                    // );
                                    setresetDataVisible(true);
                                    props.onPastDateInput(
                                      new Date(pastDate)
                                        .toISOString()
                                        .split("T")[0]
                                    );
                                  }}
                                >
                                  {"Apply"}
                                </Button>
                              </InputRightElement>
                            </InputGroup>
                            {/* <Button ml={2}>simulate new price</Button> */}
                          </Flex>
                        )}
                      </Box>
                    </BoxFlexMobile>
                  </SkeletonText>
                  {(props.averages ?? []).map((_a) => (
                    <PriceAveragesComponent
                      key={_a._title}
                      {..._a}
                    ></PriceAveragesComponent>
                  ))}
                </TabPanel>
                <TabPanel>
                  <FinancialData
                    financialData={{ ...(props.financialData ?? {}) }}
                    financialGraphs={[...(props.financialGraphs ?? [])]}
                  ></FinancialData>
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Stack>
        </CardBody>
        {/* foreach average, build its Card */}
        {/* title of the average */}
        {/* interval contains the name of the point */}
        {/* weightedAvg contains, well... that */}
        {/* priceObj.date is the date of the changing interval */}
        {/* that date can be used to give a little on context on the graph */}
      </Card>
    </Box>
  );
}

export default SymbolData;
